import { computed, inject, Injectable } from '@angular/core';
import { WorkingCompany } from 'app/core/company/working-company';

/**
 * Determines whether the "Documentation" module should be visible and accessible.
 *
 * This class centralizes the access logic for UI elements and features related to Documentation integration.
 * It is meant to be reused anywhere in the application where visibility or access to Documentation-related
 * functionality needs to be checked.
 *
 * Exposes a readonly signal `isAllowed` that reacts automatically to changes in the current user or working company.
 *
 * Access rules:
 * - The current working company must have `fromHubspot` set to true
 *   OR
 * Usage:
 *   if (this._documentationModuleAccess.isAllowed()) {
 *       // Enable Documentation features
 *   }
 */
@Injectable({ providedIn: 'root' })
export class DocumentationModuleAccess {
    private readonly _workingCompany = inject(WorkingCompany);

    readonly isAllowed = computed(() =>
        this._workingCompany.company?.fromHubspot === true
    );
}
